import { SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { HubTypeKiosklessSpacesHub } from '../../icons/HubType_KiosklessSpacesHub.icon';
import { HubTypeLockersHub } from '../../icons/HubType_LockersHub.icon';
import { HubTypeSpacesHub } from '../../icons/HubType_SpacesHub.icon';
import { SVGIconComponent } from '../../icons/types';
import { ResultIdentity } from './result-identity.component';
import { ResultItemRow } from './result-item-row.component';
import { SearchResultItemDtoSubType } from '../search.constants';
import { dataString } from '../search.utils';
import { convertHyphenated } from '../../../../../core/util/string-conversion';

/** The hub-type SVGs are authored at 18px; size up to match the other rows' 24px icons. */
const ICON_SIZE = { width: 24, height: 24 };

const HUB_SUBTYPE_ICON: Record<string, SVGIconComponent> = {
  [SearchResultItemDtoSubType.LockersHub]: HubTypeLockersHub,
  [SearchResultItemDtoSubType.ExternalLockersHub]: HubTypeLockersHub,
  [SearchResultItemDtoSubType.SpacesHub]: HubTypeSpacesHub,
  [SearchResultItemDtoSubType.KiosklessSpacesHub]: HubTypeKiosklessSpacesHub
};

export function HubResultItem({
  item,
  href,
  onClick
}: {
  item: SearchResultItemDto;
  href?: string;
  onClick?: () => void;
}) {
  const Icon = (item.subType && HUB_SUBTYPE_ICON[item.subType]) || HubTypeLockersHub;

  // Hub type + external short id — mirrors the project row's type/shortcode line.
  const typeLabel = item.subType ? convertHyphenated(item.subType, { capitalizeEachWord: true }) : undefined;
  const externalShortID = dataString(item.data, 'externalShortID');
  const typeLine = [typeLabel, externalShortID].filter(Boolean).join(' · ') || undefined;

  // Flag non-active (e.g. inactive) hubs, matching the person/project treatment.
  const status = dataString(item.data, 'status');
  const tag = status && status !== 'active' ? convertHyphenated(status, { capitalizeEachWord: true }) : undefined;

  return (
    <ResultItemRow
      icon={<Icon style={ICON_SIZE} />}
      primary={item.label}
      secondaryLines={[typeLine, dataString(item.data, 'displayAddress')]}
      tag={tag}
      trailing={
        <ResultIdentity
          name={dataString(item.data, 'projectName')}
          imageURL={dataString(item.data, 'projectImageURL')}
        />
      }
      href={href}
      onClick={onClick}
    />
  );
}
